<template>
    <PopupRouterViewDetail label="Printer Information Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Printer Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-printer-ip-address" label-cols-lg="12"  label="IP Address" label-for="input-printer-ip-address" size="sm" :model.sync="model.printerIpAddress"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-printer-port" label-cols-lg="12"  label="Port" label-for="input-printer-port" size="sm" :model.sync="model.printerPort"  @change="updateData" :isUpdatable ="true"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-checkbox id="fieldset-is-is-mobile-printer" label-cols-lg="12" label="Mobile Printer" label-for="input-is-is-mobile-printer" size="sm" :model.sync="model.isMobilePrinter" :isUpdatable ="true"checkedValue="Yes" uncheckedValue="No" @change="updateData" />
						<app-input-checkbox id="fieldset-is-is-disabled" label-cols-lg="12" label="Disabled" label-for="input-is-is-disabled" size="sm" :model.sync="model.isDisabled" :isUpdatable ="true"checkedValue="Yes" uncheckedValue="No" @change="updateData" />
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PrinterInformation from '@/models/PrinterInformation/PrinterInformation';
import PrinterInformationList from '@/models/PrinterInformation/PrinterInformationList';
import PrinterInformationFilter from '@/filters/PrinterInformation/PrinterInformationFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputCheckbox,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterPrinterInformation : null,
			currentPrinterInformationPage : 1,
			printerInformationPageSize: 10,
			sortByPrinterInformation: '',
			sortDescPrinterInformation: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getPrinterInformation : async function(id) {
			this.isBusy = true;
			PrinterInformation.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPrinterInformation = true;
			this.filterPrinterInformation.id = this.modelId;
			PrinterInformation.downloadDataDetail(this, this.filterPrinterInformation).then(result => {
				this.isDownloadPrinterInformation = false;
			}).catch(error => { this.isDownloadPrinterInformation = false; })
		},
		getPrinterInformations : async function(input) {
			let filter = new PrinterInformationFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isPrinterInformationComboLoading = true;
			PrinterInformation.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.printerInformations = result.data
				}
				this.isPrinterInformationComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.printerInformationInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PrinterInformation.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'printerinformationindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						PrinterInformation.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'printerinformationindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PrinterInformation.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getPrinterInformation(id);
					});
				}
			});
		},
		onHidden() {
			this.getPrinterInformations();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterPrinterInformation = new PrinterInformationFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPrinterInformation(id);
			} else {
				this.modelId = id;
				this.getPrinterInformation(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
